// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyHeader":"msnbcDailyHeader___2SuFg","scrollLink":"scrollLink___1QTPX","inner":"inner___3uDum","title":"title___26Yad","description":"description___1864R"};